import axios from "axios";
import { toast } from "sonner";
import { API } from "../App";
import { formatApiError } from "./utils";

export async function startCheckout(navigate, payload) {
  try {
    const r = await axios.post(`${API}/payments/checkout`, payload, { withCredentials: true });
    navigate("/checkout", { state: r.data });
  } catch (e) {
    toast.error(formatApiError(e, "Could not start checkout"));
  }
}
